import React, { useEffect, useState } from 'react'
import Grid4x4Icon from '@mui/icons-material/Grid4x4';
export default function Grid() {
   const [gridOpen,setGridOpen]=useState(false)
  return (
    <>
        <Grid4x4Icon onClick={()=>setGridOpen(!gridOpen)} sx={{position:'absolute',right:10,bottom:25,background:`${!gridOpen?"#007ACC":"#FF5112"}`,fontSize:28,borderRadius:"50%",p:0.8,boxSizing:"initial",cursor:'pointer'}}/>
      {gridOpen && <div class="grid elbox"><div class="inner-grid"></div></div>}
    </>
  )
}
